export const SidenavEnum = [
  {
    label: 'Новая сделка',
    href: 'new'
  },
  {
    label: 'Активные сделки',
    href: 'active'
  },
  {
    label: 'Профиль',
    href: 'personal-data'
  },
  {
    label: 'История',
    href: 'archive'
  },
  {
    label: 'Информация',
    href: 'user-info'
  },
  {
    label: 'Поддержка',
    href: 'support'
  }
];
